import { FC, memo } from 'react'
import type { Props } from '../types'

const PlayStore: FC<Props> = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g clip-path="url(#clip0_10714_56026)">
      <path
        d="M7.47353 8.43314L0.0668338 16.1931C0.151868 16.4866 0.302381 16.7569 0.507039 16.9838C0.711698 17.2108 0.965169 17.3883 1.24837 17.503C1.53157 17.6178 1.83711 17.6668 2.142 17.6464C2.44688 17.626 2.74317 17.5367 3.00854 17.3852L11.3424 12.6387L7.47353 8.43314Z"
        fill="#A4AFBB"
      />
      <path
        d="M14.9627 7.11412L11.3587 5.04996L7.30209 8.60981L11.3752 12.6277L14.9516 10.5857C15.18 10.4669 15.3828 10.3043 15.5481 10.1069C15.7134 9.90963 15.8382 9.68159 15.9151 9.43592C15.992 9.19025 16.0197 8.9318 15.9964 8.67543C15.9731 8.41905 15.8994 8.1698 15.7795 7.942C15.5924 7.58956 15.3041 7.30122 14.9516 7.11412H14.9627Z"
        fill="#C5CBD3"
      />
      <path
        d="M0.0662301 1.46809C0.0221605 1.63374 -0.00010402 1.80444 3.65342e-07 1.97585V15.6854C-0.00010402 15.8568 0.0227642 16.0274 0.0668338 16.1931L7.7268 8.63194L0.0662301 1.46809Z"
        fill="#7E8C9C"
      />
      <path
        d="M7.52872 8.83064L11.3587 5.04996L3.03613 0.28148C2.72292 0.0983455 2.36687 0.00124137 2.00405 3.94737e-06C1.56582 -0.000864494 1.13933 0.141585 0.789581 0.405639C0.439835 0.669693 0.186022 1.04087 0.0668338 1.46258L7.52872 8.83064Z"
        fill="#A4AFBB"
      />
    </g>
    <defs>
      <clipPath id="clip0_10714_56026">
        <rect width="16" height="17.6557" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default memo(PlayStore)
